import React, { Component } from 'react'
import './Title.css'

export default class Title extends Component {
    render() {
        return (
            <div>
                <h1>To Do List - React</h1>
            </div>
        )
    }
}